document.addEventListener('DOMContentLoaded', function () {
  const dropdownButton = document.getElementById('dropdownMenuThemes');
  const dropdownItems = document.querySelectorAll('#themesTab .dropdown-item');

  dropdownItems.forEach(item => {
    item.addEventListener('click', function () {
      const selectedText = this.textContent.trim();
      dropdownButton.textContent = selectedText;
    });
  });

  const activeItem = document.querySelector('#themesTab .dropdown-item.active');
  if (activeItem) {
    dropdownButton.textContent = activeItem.textContent.trim();
  }
});
